import { Component } from "@angular/core";
import { LoginService } from "../../services/login.service";

@Component({
  standalone: false,
  selector: "sol-login",
  templateUrl: "login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent {
  public email: string = "";
  public password: string = "";

  constructor(private loginService: LoginService) {}

  async onLogin() {
    await this.loginService.login(this.email, this.password);
  }
}
